function getByteLength(s) {
    if (!s) return 0;
    let b = 0;
    for (let i = 0; i < s.length; i++) {
        const c = s.charCodeAt(i);
        b += c >> 11 ? 3 : c >> 7 ? 2 : 1;
    }
    return b;
}

export default getByteLength;
